__turbopack_context__.v({
  "className": "manrope_151467da-module__iDRY9W__className",
});
